import ahoy from 'ahoy.js'
import 'core-js/web/url'

const isATag = (el: HTMLElement): el is HTMLAnchorElement => {
  return el.tagName == "A"
}

const closestParentLink = (el: HTMLElement | null): HTMLAnchorElement | null => {
  if (!el) {
    return null
  }

  if (isATag(el) && el.href) {
    return el
  } else {
    return closestParentLink(el.parentElement)
  }
}

const rootHost = document.querySelector<HTMLMetaElement>(`meta[name="root_host"]`)?.content

if (rootHost) {
  document.addEventListener("click", (event) => {
    let target = event.target
    let aEl = closestParentLink(target as HTMLElement)
    if (aEl && aEl.href.match(rootHost) && document.location.hostname != rootHost) {
      let url = new URL(aEl.href)
      url.searchParams.append("visit_token", ahoy.getVisitId())
      url.searchParams.append("visitor_token", ahoy.getVisitorId())
      aEl.href = url.toString()
    }
  })
}